import React from "react";
import Stock from "../components/Stock";

export const StockPage=()=>{

    return(
        <div>
            <Stock />
        </div>
    )
}